import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom, throwError } from 'rxjs';
import { filter, take, timeout } from 'rxjs/operators';
import { RoutesEnum } from '../configuration/enums/routes.enum';
import { PaymentModulesEnum } from '../configuration/payment-modules/payment-module-class';
import { AppState } from '../store';
import { selectPaymentModule } from '../store/states/payment/payment.selectors';

const RESTRICTED_PAYMENT_MODULES = [
  PaymentModulesEnum.LOGGED_AREA,
  PaymentModulesEnum.FAST_CHECKOUT,
  PaymentModulesEnum.PASSWORD_LESS,
  PaymentModulesEnum.DEFAULT,
];

const BYPASS_EMPTY_PATH_GUARD_FOR = new Set<string>([
  RoutesEnum.NOT_FOUND,
  RoutesEnum.ERROR,
  RoutesEnum.MAINTENANCE,
  RoutesEnum.PAYMENT_PROCESSED,
  RoutesEnum.RECEIPT_MANAGEMENT,
  RoutesEnum.TRANSACTION_RECEIPT,
  RoutesEnum.CONSULT_ACCOUNTS,
]);

const isValidPaymentLinkModule = (module: string): boolean => {
  return !RESTRICTED_PAYMENT_MODULES.includes(module as PaymentModulesEnum);
};
const PAYMENT_MODULE_WAIT_MS = 10_000;

export const paymentLinkInitGuard: CanMatchFn = async (_route, segments) => {
  const firstPath = segments[0]?.path;
  if (firstPath && BYPASS_EMPTY_PATH_GUARD_FOR.has(firstPath)) {
    return false;
  }

  const store = inject(Store<AppState>);
  const router = inject(Router);

  try {
    await firstValueFrom(
      store.select(selectPaymentModule).pipe(
        filter(isValidPaymentLinkModule),
        timeout({
          first: PAYMENT_MODULE_WAIT_MS,
          with: () => throwError(() => new Error('timeout')),
        }),
        take(1)
      )
    );
    return true;
  } catch (error) {
    console.error('initialization failed', error);
    return router.createUrlTree([RoutesEnum.NOT_FOUND]);
  }
};
